import { TabGroup, Tabs } from '@by-miles/bymiles-styles'
import { useContext, useEffect, useState } from 'react'

import { useQuote } from '../../../../hooks/useQuote'
import { useDriverPageContext } from '../../../../pages/DriverPageProvider'
import { usePreQuoteContext } from '../../../../pages/PageValidator'
import { ProviderContext } from '../../../../Provider'
import { lastNameSubstring } from '../../../../utils/lastNameSubstring'
import { DriversTabGroupStyle } from './DriversTabGroupStyle'

export const DriversTabGroup = () => {
  const quote = useQuote()
  const {
    state: { showModal, selectedDriverIndex },
  } = useContext(ProviderContext)
  const { validateTransition } = usePreQuoteContext()
  const { updatedDriverDetails, updatedAdditionalDriver, handleDriverEdit, updatingDrivers } = useDriverPageContext()

  const [tabNames, setTabNames] = useState<Tabs[]>([])

  const handleAdditionalDriverName = (driver: any, i: number, shorthand?: boolean) => {
    const firstName = driver?.first_names || 'Driver'
    const formatedLastName =
      shorthand && driver?.last_names ? `${lastNameSubstring(driver?.last_names)}.` : driver?.last_names
    const lastNamePlaceholder = driver?.first_names ? '' : i + 2
    const lastName = formatedLastName && firstName !== 'Driver' ? formatedLastName : lastNamePlaceholder
    return `${firstName} ${lastName}`
  }

  const handleTabNames = () => {
    const primaryLastName = updatedDriverDetails.lastNames || quote?.details?.proposer?.last_names || 'Driver'
    const formatedLastName = lastNameSubstring(primaryLastName)
    const primaryDriverName = `${
      updatedDriverDetails.firstNames || quote?.details?.proposer?.first_names || 'Primary'
    } ${formatedLastName}.`
    const additionalNames =
      quote?.details?.additional_drivers?.map((driver, i) => {
        const updatedDriver = i === selectedDriverIndex - 1 ? updatedAdditionalDriver : driver
        return handleAdditionalDriverName(updatedDriver, i, true)
      }) || []
    const names = [primaryDriverName, ...additionalNames]
    return names.map(name => {
      return { label: name }
    })
  }

  useEffect(() => {
    setTabNames(handleTabNames())
  }, [
    selectedDriverIndex,
    quote?.details?.additional_drivers,
    updatedDriverDetails?.lastNames,
    updatedDriverDetails?.firstNames,
    updatedAdditionalDriver?.first_names,
    updatedAdditionalDriver?.last_names,
  ])

  return (
    <DriversTabGroupStyle>
      <TabGroup
        tabs={tabNames}
        onTabClick={(tab: number) => handleDriverEdit(tab - 2)}
        activeTabNumber={selectedDriverIndex + 1}
        validateTabClick={() => validateTransition()}
        disabled={updatingDrivers || showModal}
      />
    </DriversTabGroupStyle>
  )
}
